exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){.max-height img{position:relative}}.max-height img{position:fixed}.swiper-container .swiper-slide{min-height:-webkit-fill-available;line-height:300px}.swiper-container{overflow:visible}.template-images img{outline:1px solid #323232}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55e6554e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/store/components/CardHorizontal.vue
// module id = nWWH
// module chunks = 102